const KEY = 'EVENT-FEEDBACK';

export { KEY };
